import moment from "moment";

const isSouthAfricaIdChecksumValid = (value: string, checkDigit: number): boolean => {
  let sum = 0;
  for (var i = 0; i < 12; i++) {
    const digit = +value.substring(i, i + 1);
    const processedDigit = (digit * 2) % 9;
    sum += i % 2 === 0 ? digit : processedDigit === 0 && digit !== 0 ? 9 : processedDigit;
  }

  return (10 - (sum % 10)) % 10 === checkDigit;
};

export type SouthAfricaId = {
  age: number;
  gender: "female" | "male";
};
export const parseSouthAfricaId = (value: string): SouthAfricaId | null => {
  const adjustedValue = value.replace(/\s*/g, "");

  const m = adjustedValue.match(
    /^(?<year>\d{2})(?<month>\d{2})(?<day>\d{2})(?<gender>\d{4})(?<citizen>\d{1})(?<race>\d{1})(?<checksum>\d{1})$/
  );
  if (!m?.groups) return null;

  if (
    +m.groups["month"] < 1 ||
    +m.groups["month"] > 12 ||
    +m.groups["day"] < 1 ||
    +m.groups["day"] > 31 ||
    +m.groups["citizen"] > 1 ||
    +m.groups["race"] < 8
  )
    return null;

  if (!isSouthAfricaIdChecksumValid(adjustedValue, +m.groups["checksum"])) return null;

  const currentYearTwoDigits = +new Date().getFullYear().toString().substring(2, 4);
  // 19xx or 20xx
  const bestGuessYear = `${+m.groups["year"] < currentYearTwoDigits ? 20 : 19}${m.groups["year"]}`;

  const birthday = new Date(+bestGuessYear, +m.groups["month"], +m.groups["day"]);

  const age = moment().diff(moment(birthday, "YYYYMMDD"), "years");
  const gender = +m.groups["gender"] < 5000 ? "female" : "male";

  return { age, gender };
};
